export default "__VITE_ASSET__6911a5bf__"